const values = [
	{
		text: "Noch offen",
	},
	{
		text: "Abgelehnt",
	},
	{
		text: "Ersatzlieferung",
	},
	{
		text: "Nacharbeit",
	},
	{
		text: "Gutschrift",
	},
];

export default values;
